import { scrollToError } from '@seek/ca-myprofile-utils';

import {
  CREATE_RESUME_OFFSET_MOBILE,
  CREATE_RESUME_OFFSET_DESKTOP,
} from 'src/consts';
import { isSmallDevice } from 'src/modules/device';
import type { Page } from 'src/types';

import { CREATE_RESUME_PAGE } from '../Router';

export const onSubmitFail = (errors: string[], page: Page) => {
  const isMobile = isSmallDevice();
  const offset = isMobile
    ? CREATE_RESUME_OFFSET_MOBILE
    : CREATE_RESUME_OFFSET_DESKTOP;
  scrollToError(errors, page === CREATE_RESUME_PAGE ? offset : undefined);
};
